var _style, _path, _g, _g2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107.3 35.2",
    style: {
      enableBackground: "new 0 0 107.3 35.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFF;}\n\t.st1{fill:#FFF;}\n\t.st2{fill:#FFF;}\n\t.st3{fill:#FFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.4,12.4H13.9v3.7h8.9c-0.4,5.2-4.8,7.4-8.9,7.4c-5.4,0-9.8-4.3-9.8-9.7c0-0.1,0-0.1,0-0.2 c0-5.6,4.4-10,9.8-10c4.2,0,6.7,2.7,6.7,2.7l2.6-2.7c0,0-3.3-3.7-9.4-3.7C6,0,0,6.5,0,13.6c0,6.9,5.6,13.7,14,13.7 c7.3,0,12.7-5,12.7-12.4C26.6,13.3,26.4,12.4,26.4,12.4L26.4,12.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "st1",
    d: "M36.6,9.7c-5.1,0-8.8,4-8.8,8.7c0,4.8,3.6,8.8,8.9,8.8c4.8,0,8.7-3.7,8.7-8.7 C45.4,12.7,40.9,9.7,36.6,9.7L36.6,9.7z M36.7,13.2c2.5,0,4.9,2,4.9,5.3c0,3.2-2.4,5.3-4.9,5.3c-2.8,0-5-2.2-5-5.3 C31.7,15.4,33.9,13.2,36.7,13.2L36.7,13.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "A_00000013188963515725144280000010447546747560242603_",
    className: "st2",
    d: "M55.8,9.7c-5.1,0-8.8,4-8.8,8.7 c0,4.8,3.6,8.8,8.9,8.8c4.8,0,8.7-3.7,8.7-8.7C64.6,12.7,60,9.7,55.8,9.7L55.8,9.7z M55.9,13.2c2.5,0,4.9,2,4.9,5.3 c0,3.2-2.4,5.3-4.9,5.3c-2.8,0-5-2.2-5-5.3C50.9,15.4,53,13.2,55.9,13.2L55.9,13.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.6,9.7c-4.7,0-8.4,4.1-8.4,8.8c0,5.3,4.3,8.8,8.3,8.8c2.5,0,3.8-1,4.8-2.1v1.7c0,3-1.8,4.8-4.6,4.8 c-2.7,0-4-2-4.5-3.1L66.9,30c1.2,2.5,3.6,5.2,7.9,5.2c4.7,0,8.3-3,8.3-9.1V10.3h-3.7v1.5C78.2,10.5,76.7,9.7,74.6,9.7L74.6,9.7z  M75,13.2c2.3,0,4.7,2,4.7,5.3c0,3.4-2.4,5.3-4.7,5.3c-2.5,0-4.9-2-4.9-5.3C70.1,15.2,72.5,13.2,75,13.2L75,13.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.4,9.7c-4.4,0-8.2,3.5-8.2,8.8c0,5.5,4.2,8.8,8.6,8.8c3.7,0,6-2,7.4-3.8l-3-2c-0.8,1.2-2.1,2.4-4.3,2.4 c-2.5,0-3.6-1.3-4.3-2.7l11.8-4.9l-0.6-1.4C105.6,12.1,102.9,9.7,99.4,9.7L99.4,9.7z M99.6,13.1c1.6,0,2.8,0.9,3.2,1.9l-7.9,3.3 C94.6,15.7,97,13.1,99.6,13.1L99.6,13.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.6,26.8h3.9V0.9h-3.9V26.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.ef7d1a96cec3d1f24e9413e484670e20.svg";
export { ForwardRef as ReactComponent };